import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";
import useDriver from "./useDriver";
import useDrivers from "../useDrivers";
import useDriverTeams from "./useDriverTeams";
import useDriverCharges from "./useDriverCharges";
import useDriverConfig from "./useDriverConfig";
import useDriverKYC from "./useDriverKYC";
import useDriverKYCUpload from "./useDriverKYCUpload";
import useNotification from "../useNotification";

export default function useDriverAllApi() {
  const { baseurl, accessToken, AdminId, setIsUnauthorised,token } =
    useGlobalContext();
  const [teamMembersByTeamId, setTeamMembersByTeamId] = useState({});
  const [teamMembersLoadingId, setTeamMembersLoadingId] = useState(null);
  const {
    drivers,
    loading,
    fetchDrivers,
    deleteDriver,
    toggleDutyStatus,
    createDriverApi,
    AssignTaskToDriver,
  } = useDriver();
  const { editDriverApi, updateDriverDutyApi } = useDrivers();
  //  TEAMS
  const {
    teams,
    teamsLoading,
    fetchDriverTeams,
    driverTeams,
    loadingTeams,
    fetchDriverMultipleTeams,
    updateDriverActiveTeam,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
  } = useDriverTeams();

  // CHARGES
  const {
    chargeRows,
    chargesLoading,
    fetchDriverCharges,
    fetchChargesForDriverApi,
    saveDriverChargeApi,
  } = useDriverCharges(drivers);

  //  CONFIG
  const {
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,
  } = useDriverConfig();

  // KYC
  const {
    kycDrivers,
    fetchDriverKycDetails,
    handleKycAction,
    handleStepSubmit,
  } = useDriverKYC();

  //  KYC UPLOAD
  const { uploadImageToServer } = useDriverKYCUpload();

  // notification
  const { sendNotification } = useNotification();
  const fetchDriverTeamListByTeamId = async (teamId, force = false) => {
    if (!teamId) return null;

    if (!force && teamMembersByTeamId[teamId]) {
      return teamMembersByTeamId[teamId];
    }

    setTeamMembersLoadingId(teamId);

    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverTeamListByTeamId`,
        {
          teamId: String(teamId),
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (res.data?.responseCode === "00") {
        const raw = Array.isArray(res.data?.data) ? res.data.data[0] || {} : {};

        const normalized = {
          primaryTeamDrivers: Array.isArray(raw?.primaryTeamDrivers)
            ? raw.primaryTeamDrivers
            : [],
          secondaryTeamDrivers: Array.isArray(raw?.secondaryTeamDrivers)
            ? raw.secondaryTeamDrivers
            : [],
          activeTeamDrivers: Array.isArray(raw?.activeTeamDrivers)
            ? raw.activeTeamDrivers
            : [],
        };

        setTeamMembersByTeamId((prev) => ({
          ...prev,
          [teamId]: normalized,
        }));

        return normalized;
      } else if (
        res.data?.responseCode === "401" ||
        res.data?.responseCode === "98"
      ) {
        setIsUnauthorised(true);
        return null;
      } else {
        toast.error(
          res.data?.responseMessage || "Failed to fetch team member details",
        );
        return null;
      }
    } catch (err) {
      console.error("fetchDriverTeamListByTeamId error:", err);
      toast.error("Error fetching team member details");
      return null;
    } finally {
      setTeamMembersLoadingId(null);
    }
  };
  //  COMBINE EVERYTHING
  return {
    drivers,
    kycDrivers,
    loading,
    teams,
    fetchDriverTeams,
    fetchDrivers,
    editDriverApi,
    updateDriverDutyApi,
    driverTeams,
    updateDriverActiveTeam,
    loadingTeams,
    fetchDriverMultipleTeams,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
    deleteDriver,
    toggleDutyStatus,

    // configs
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,

    // charges
    chargeRows,
    chargesLoading,
    fetchDriverCharges,
    fetchChargesForDriverApi,
    saveDriverChargeApi,

    // KYC helpers (MOST IMPORTANT FIX)
    uploadImageToServer,
    handleStepSubmit,
    fetchDriverKycDetails,
    handleKycAction: handleKycAction,

    // config helpers
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,
    AssignTaskToDriver,
    y: sendNotification,


    // team new api
    teamMembersByTeamId,
teamMembersLoadingId,
fetchDriverTeamListByTeamId,
  };
}
